var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsCardServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4644.000000, -972.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Card-services",
    transform: "translate(4644.000000, 972.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.178623,30.545 C12.3736528,30.545 11.7236769,29.894 11.7236769,29.091 C11.7236769,28.288 12.3736528,27.637 13.178623,27.637 C13.9825932,27.637 14.6325692,28.288 14.6325692,29.091 C14.6325692,29.894 13.9825932,30.545 13.178623,30.545 L13.178623,30.545 Z M19.9993704,25.984 L5.99988889,25.984 L5.99988889,4 L19.9913707,4 L19.9913707,7 L22.9992593,7 L22.9992593,0 L6.99985186,0 C4.79093367,0 3,1.791 3,4 L3,32 L18.9994074,32 C21.2083256,32 22.9992593,30.209 22.9992593,28 L22.9992593,23 L19.9993704,23 L19.9993704,25.984 Z M14.9995556,18 L27.9990741,18 L27.9990741,17 L14.9995556,17 L14.9995556,18 Z M14.9995556,15 L19.9993704,15 L19.9993704,12 L14.9995556,12 L14.9995556,15 Z M28.4200585,9.016 L14.6685678,9.016 C13.5886078,9.016 12.9996296,9.524 12.9996296,10.587 L12.9996296,19.426 C12.9996296,20.488 13.5886078,21 14.6685678,21 L28.4200585,21 C29.5000185,21 29.9910003,20.488 29.9910003,19.426 L30,10.587 C30,9.524 29.5000185,9.016 28.4200585,9.016 L28.4200585,9.016 Z",
    id: 80
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsCardServices);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-card-services.7d35f265.svg";
export { ForwardRef as ReactComponent };